import { render, staticRenderFns } from "./k-grid-column.vue?vue&type=template&id=625c5c85"
import script from "./k-grid-column.vue?vue&type=script&lang=js"
export * from "./k-grid-column.vue?vue&type=script&lang=js"
import style0 from "./k-grid-column.vue?vue&type=style&index=0&id=625c5c85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports